import moment from 'moment-timezone';

export const formatDateTimeZone = (date, timeZone, format = '') => {
  if (!timeZone) return null;
  if (!date) return null;
  return moment(date).tz(timeZone).format(format);
};

/**
 * A time in the account's time zone, named the way the app names it — "10:17 AM US/Eastern
 * (UTC -04:00)": the visit page's Submitted time, the retailer notes. Null without a date or zone.
 */
export const formatTimeWithZone = (date, timeZone) => {
  if (!timeZone || !date) return null;
  return `${formatDateTimeZone(date, timeZone, 'LT')} ${timeZone} (UTC ${formatDateTimeZone(date, timeZone, 'Z')})`;
};
